export const MAX_JSON_PAYLOAD_BYTES = 100 * 1024;

export function getJsonUtf8ByteLength(obj: unknown): number {
  const s = JSON.stringify(obj);
  return new TextEncoder().encode(s).length;
}

/**
 * Rejects oversized JSON bodies before they hit Netlify (e.g. huge Notes paste).
 */
export function assertPayloadUnderLimit(obj: unknown, label = "Request"): void {
  const n = getJsonUtf8ByteLength(obj);
  if (n <= MAX_JSON_PAYLOAD_BYTES) return;
  const err = new Error(
    `${label}: Payload too large (${Math.ceil(n / 1024)}KB). Max ${MAX_JSON_PAYLOAD_BYTES / 1024}KB.`,
  ) as Error & { code?: string };
  err.code = "PAYLOAD_TOO_LARGE";
  throw err;
}
